<template>
    <table id="equity-growth-table" class="table table-striped">
        <thead>
        <tr>
            <th scope="col" class="table-column" style="width: 22%;"><span class="col-header">Year</span></th>
            <th scope="col" class="table-column" style="width: 26%;"><span class="col-header">Property Value</span></th>
            <th scope="col" class="table-column" style="width: 26%;"><span class="col-header">Loan</span></th>
            <th scope="col" class="table-column total-equity" style="width: 26%;"><span class="col-header">Total Equity</span></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th scope="row">0</th>
            <td>${{ propertyValueYear1 }}</td>
            <td>${{ loanValueValueYear1 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear1 }}</td>
        </tr>
        <tr>
            <th scope="row">1</th>
            <td>${{ propertyValueYear2 }}</td>
            <td>${{ loanValueValueYear2 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear2 }}</td>
        </tr>
        <tr>
            <th scope="row">2</th>
            <td>${{ propertyValueYear3 }}</td>
            <td>${{ loanValueValueYear3 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear3 }}</td>
        </tr>
        <tr>
            <th scope="row">3</th>
            <td>${{ propertyValueYear4 }}</td>
            <td>${{ loanValueValueYear4 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear4 }}</td>
        </tr>
        <tr>
            <th scope="row">4</th>
            <td>${{ propertyValueYear5 }}</td>
            <td>${{ loanValueValueYear5 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear5 }}</td>
        </tr>
        <tr>
            <th scope="row">5</th>
            <td>${{ propertyValueYear6 }}</td>
            <td>${{ loanValueValueYear6 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear6 }}</td>
        </tr>
        <tr>
            <th scope="row">6</th>
            <td>${{ propertyValueYear7 }}</td>
            <td>${{ loanValueValueYear7 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear7 }}</td>
        </tr>
        <tr>
            <th scope="row">7</th>
            <td>${{ propertyValueYear8 }}</td>
            <td>${{ loanValueValueYear8 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear8 }}</td>
        </tr>
        <tr>
            <th scope="row">8</th>
            <td>${{ propertyValueYear9 }}</td>
            <td>${{ loanValueValueYear9 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear9 }}</td>
        </tr>
        <tr>
            <th scope="row">9</th>
            <td>${{ propertyValueYear10 }}</td>
            <td>${{ loanValueValueYear10 }}</td>
            <td class="total-equity-value">${{ totalEquityValueYear10 }}</td>
        </tr>
        <tr class="last-row">
            <th scope="row">10</th>
            <td>${{ propertyValueYear11 }}</td>
            <td>${{ loanValueValueYear11 }}</td>
            <td class="total-equity">${{ totalEquityValueYear11 }}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: "equity-growth-table",
        computed: {
            propertyValueYear1() {
                return this.$store.state.results.getPropertyValueYear1().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear2() {
                return this.$store.state.results.getPropertyValueYear2().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear3() {
                return this.$store.state.results.getPropertyValueYear3().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear4() {
                return this.$store.state.results.getPropertyValueYear4().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear5() {
                return this.$store.state.results.getPropertyValueYear5().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear6() {
                return this.$store.state.results.getPropertyValueYear6().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear7() {
                return this.$store.state.results.getPropertyValueYear7().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear8() {
                return this.$store.state.results.getPropertyValueYear8().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear9() {
                return this.$store.state.results.getPropertyValueYear9().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear10() {
                return this.$store.state.results.getPropertyValueYear10().toLocaleString('en-US',{useGrouping:true});
            },
            propertyValueYear11() {
                return this.$store.state.results.getPropertyValueYear11().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear1() {
                return this.$store.state.results.getLoanYear1().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear2() {
                return this.$store.state.results.getLoanYear2().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear3() {
                return this.$store.state.results.getLoanYear3().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear4() {
                return this.$store.state.results.getLoanYear4().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear5() {
                return this.$store.state.results.getLoanYear5().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear6() {
                return this.$store.state.results.getLoanYear6().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear7() {
                return this.$store.state.results.getLoanYear7().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear8() {
                return this.$store.state.results.getLoanYear8().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear9() {
                return this.$store.state.results.getLoanYear9().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear10() {
                return this.$store.state.results.getLoanYear10().toLocaleString('en-US',{useGrouping:true});
            },
            loanValueValueYear11() {
                return this.$store.state.results.getLoanYear11().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear1() {
                return this.$store.state.results.getTotalEquityYear1().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear2() {
                return this.$store.state.results.getTotalEquityYear2().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear3() {
                return this.$store.state.results.getTotalEquityYear3().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear4() {
                return this.$store.state.results.getTotalEquityYear4().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear5() {
                return this.$store.state.results.getTotalEquityYear5().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear6() {
                return this.$store.state.results.getTotalEquityYear6().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear7() {
                return this.$store.state.results.getTotalEquityYear7().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear8() {
                return this.$store.state.results.getTotalEquityYear8().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear9() {
                return this.$store.state.results.getTotalEquityYear9().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear10() {
                return this.$store.state.results.getTotalEquityYear10().toLocaleString('en-US',{useGrouping:true});
            },
            totalEquityValueYear11() {
                return this.$store.state.results.getTotalEquityYear11().toLocaleString('en-US',{useGrouping:true});
            }
        }
    }
</script>

<style scoped>

    #equity-growth-table {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        color: #465978;
    }

    tr {
        width: 280px;
    }

    td, th {
        border: 1px solid #fff;
    }

    thead, .last-row {
        background-color: #465978 !important;
        color: #fff;
    }

    .table-column {
        border: 1px solid #fff;
        height: 50px;
        line-height: 50px;
    }

    .col-header {
        display: inline-block;
        vertical-align: middle;
        line-height: normal;
    }

    .total-equity {
        background-color: #ee3124;
    }

    .total-equity-value {
        color: #ee3124;
    }

    .total-equity-value {
        background-color: #ffe6e6;
    }

    .table-striped > tbody > tr:nth-child(2n+1) > .total-equity-value {
        background-color: #ffcccc;
    }
    
    @media (min-width: 768px) and (max-width: 1044px) {
        td, th {
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media (min-width: 768px) and (max-width: 900px) {
        #equity-growth-table {
            font-size: 15px;
        }
    }

    @media (max-width: 369px) {
        td, th {
            padding-left: 0;
            padding-right: 0;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/EquityGrowthTable.vue